interface TypedFetchResponse<T> extends Response {
  json: () => Promise<T>;
}

/** Fetch but you can specify the response type. */
export const typedFetch: <R>(
  ...args: Parameters<typeof fetch>
) => Promise<TypedFetchResponse<R>> = fetch;
